<template>
  <div>
    <orderDetail
      v-if="!isConfirm && computedOrderData.orderId"
      :computedOrderData="computedOrderData"
    ></orderDetail>
    <orderConfirm v-else-if="computedOrderData.orderId" :computedOrderData="computedOrderData"></orderConfirm>
  </div>
</template>

<script>
import CARDICT from '@/store/dict/carDict.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'
import orderConfirm from './components/orderConfirm'
import orderDetail from './components/orderDetail'

export default {
  name: 'OrderInformation',
  components: {
    orderDetail,
    orderConfirm,
  },
  data() {
    return {
      isConfirm: false,
    }
  },
  inject: ['orderData'],
  watch: {
  },
  computed: {
    ...mapState({
      paymentMethods: (state) => state.global.paymentMethods, // 付款方式
    }),
    computedOrderData() {
      const _data = { ...this.orderData }
      if (!_data.orderId) {
        _data.orderId = this.$route.query.id
      }
      // 客户类型
      _data.customerTypeName = SelectOption.customertypeDict[String(_data.customerType)]
      // 签约方式 根据签署类型signType和签署渠道signChannel两个字段判断
      _data.signChannelName = ''
      if (SelectOption.signingType[_data.signType]) {
        _data.signChannelName += SelectOption.signingType[_data.signType]
        if (SelectOption.signingChannel[_data.signChannel]) {
          _data.signChannelName += `(${SelectOption.signingChannel[_data.signChannel]})`
        }
      }
      // 应收押金
      _data.receivableDeposit = `${_data.deposit ? this.numberWithCommas(_data.deposit) : '0.00'}/${_data.receivedDeposit ? this.numberWithCommas(_data.receivedDeposit) : '0.00'}`
      if (_data.receivableDeposit === '0.00/0.00') {
        _data.receivableDeposit = '--'
      }
      // 订单关联原因
      _data.rderRelatedReasonName = SelectOption.rderRelatedReason[String(_data.relatedType)]
      // 租赁订单状态
      _data.stateName = SelectOption.leaseOrderState[_data.state]
      _data.contractState = _data.contractState === null ? 0 : _data.contractState
      // 合同签署状态
      _data.contractStateName = SelectOption.leaseOrderContractState[String(_data.contractState)]
      const errorReason = _data.failReason ? `，失败原因:${_data.failReason}` : ''
      // 车辆库存状态
      _data.inventoryStateName = _data.inventoryState || _data.inventoryState === 0 ? CARDICT.OUT_INT_STATE()[_data.inventoryState - 0] : '--'
      if (this.isConfirm) {
        // 合同签署状态会有失败时，添加原因
        _data.contractStateName += errorReason
      }
      // 订单结算状态
      _data.settlementStateName = SelectOption.settlementForm[_data.settlementState]
      // 支付形式
      this.paymentMethods.forEach((item) => {
        if (Number(item.code) === Number(_data.payMode)) {
          _data.payModeName = item.name
        }
      })
      // 租金收款方式
      _data.payMethodName = SelectOption.payMethods[_data.payMethod]
      // 客户确认状态
      _data.confirmStateName = SelectOption.confirmStateList[_data.confirmWithholdState]
      // 支付计划类型
      _data.payTypeName = SelectOption.paymenttypeDict[_data.payType]
      // 赠送天数
      _data.presentDaysName = _data.presentDays ? `${_data.presentDays}日` : ''
      // 是否关联订单
      _data.relatedOrderIdName = _data.relatedOrderId || _data.relatedOrderId === 0 ? '是' : '否'
      // 附件url
      _data.contractUrl = this.getURL({ data: _data.contractUrl, needName: true, defaultImg: [] })
      // 处理后的url
      _data.computedContractUrl = _data.contractUrl.length ? _data.contractUrl[0].url : ''
      // 如果是新滞纳金则处理滞纳金收取比例和免息天数数据
      if (_data.lateFeeOpen === 1) {
        _data.lateFeeProportion = `未付租金*${_data.lateFeeProportion}%/日`
        _data.interestFreeDays = `${_data.interestFreeDays}天`
      }

      // 阶梯配置详情
      // 处理阶梯数据
      let ladderIsOpen = 0
      let ladderList = []
      const { isOpen = 0, feePiecewiseConfigList = [] } = _data.feeConfig?.feePiecewiseCalculation || {}
      ladderIsOpen = isOpen
      ladderList = feePiecewiseConfigList
      if (_data.rentCategory === 3) {
        // eslint-disable-next-line no-shadow
        const { isOpen = 0, piecewiseConfigList = [] } = _data.orderConfig?.piecewiseCalculation || {}
        ladderIsOpen = isOpen
        ladderList = piecewiseConfigList
      }
      _data.isOpen = SelectOption.schemeTypeList[Number(ladderIsOpen)]
      // eslint-disable-next-line no-mixed-operators
      _data.piecewiseConfigList = ladderIsOpen === 1 && ladderList.map((item) => {
        return {
          ladderDate: `${item.startMonth}至${item.endMonth}月`,
          amount: item.amount,
        }
        // eslint-disable-next-line no-mixed-operators
      }) || []

      const addRMB = ['rentAmount', 'deposit', 'manageAmount', 'serviceAmount']

      addRMB.forEach((item) => {
        if (_data[item] || _data[item] === 0) {
          _data[item] = `${_data[item]}元`
        }
      })
      const result = SelectOption.categoryList[_data.rentCategory]
      _data.rentCategory = result || '--'

      return _data
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'payMode' }) // 获取付款方式
    const { confirm } = this.$route.query
    if (String(confirm) === '1') {
      this.isConfirm = true
    }
  },
  methods: {
  },
}
</script>
